module.exports = __webpack_public_path__ + "img/1.71d17f4c.jpg";